// @flow

import * as React from 'react';

type Props = {|
  children: string,
|};

// usually the widest number in a font
const WIDEST_NUMBER = 4;
const LONG_STRING_FROM_WIDEST_NUMBER = Array.from(Array(100)).fill(
  WIDEST_NUMBER,
);

const Monospace = ({
  children,
  widthFrom,
}: {|
  children: React.Node,
  widthFrom: React.Node,
|}) => {
  // &#8203; is a zero width space
  return (
    <div
      css={{
        display: 'inline-block',
        position: 'relative',
      }}
    >
      &#8203;
      <span
        css={{
          visibility: 'hidden',
        }}
      >
        {widthFrom}
      </span>
      <div
        css={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};

const SPLITTER = '4207ff80-9f2a-4e9d-91e2-4b99ffb19736';

// Its emulation of monospace using non monospaced fonts
// we use widest numeric character to aquire size for a number.
// Visually this has almost no difference and allow to reduce jumping of changing strings
export const NumberMonospace = ({ children }: Props): React.Node => {
  const re = /([\d]+)/g;
  const preparedTextArr = children
    .replace(re, `${SPLITTER}$1${SPLITTER}`)
    .split(SPLITTER);

  return preparedTextArr.map<React.Node>((text, index) =>
    index % 2 === 0 ? (
      <span key={index}>{text}</span>
    ) : (
      <Monospace
        key={index}
        widthFrom={LONG_STRING_FROM_WIDEST_NUMBER.slice(0, text.length)}
      >
        {text}
      </Monospace>
    ),
  );
};
